// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD9vHZAX8egdxuimwZOy24MKKEFUdzy6jU",
  authDomain: "leaderboard-7310f.firebaseapp.com",
  projectId: "leaderboard-7310f",
  storageBucket: "leaderboard-7310f.appspot.com",
  messagingSenderId: "58227242007",
  appId: "1:58227242007:web:89b7dbe11db5db83f6d852",
  measurementId: "G-DD3RVFF9H8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);